//
//  SDKBorderPosition.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var BorderPosition;
(function (BorderPosition) {
    BorderPosition["inside"] = "Inside";
    BorderPosition["center"] = "Center";
    BorderPosition["outside"] = "Outside";
})(BorderPosition || (BorderPosition = {}));
export const ALL_BORDER_POSITIONS = [
    BorderPosition.inside,
    BorderPosition.center,
    BorderPosition.outside,
];
